<template>
  <button
    :type="type"
    :disabled="disabled || loading"
    :class="[
      'inline-flex items-center justify-center select-none',
      'rounded-md px-4 py-2 text-sm font-medium transition-colors duration-150',
      'focus:outline-none focus:ring-2 focus:ring-offset-1',
      (disabled || loading) ? 'opacity-50 cursor-not-allowed' : '',
      variantClasses,
      sizeClasses
    ]"
    @click="onClick"
  >
    <svg
      v-if="loading"
      class="mr-2 h-4 w-4 animate-spin"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path class="opacity-75" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" fill="currentColor" />
    </svg>
    <slot />
  </button>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'BaseButton',
  props: {
    type:     { type: String,  default: 'button' },   // 'button' | 'submit'
    variant:  { type: String,  default: 'primary' },  // 'primary' | 'secondary' | 'danger' | 'ghost'
    size:     { type: String,  default: 'md' },       // 'sm' | 'md' | 'lg'
    loading:  { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['click'],
  setup(props, { emit }) {
    const variantClasses = computed(() => {
      switch (props.variant) {
        case 'secondary':
          return 'bg-gray-100 text-gray-800 hover:bg-gray-200 focus:ring-gray-300';
        case 'danger':
          return 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-400';
        case 'ghost':
          return 'bg-transparent text-gray-700 hover:bg-gray-100 focus:ring-gray-300';
        default: // primary
          return 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-400';
      }
    });

    const sizeClasses = computed(() => {
      switch (props.size) {
        case 'sm': return 'px-3 py-1.5 text-sm';
        case 'lg': return 'px-5 py-2.5 text-base';
        default:   return 'px-4 py-2 text-sm';
      }
    });

    function onClick(e) {
      if (props.disabled || props.loading) return;
      emit('click', e);
    }

    return { variantClasses, sizeClasses, onClick };
  }
};
</script>

<!-- No <style> block -> no @apply / @reference needed -->
